var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlueCaret(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 5,
    height: 8,
    viewBox: "0 0 5 8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "caret-down",
    d: "M11.833,192h6.923a.6.6,0,0,1,.379,1.011l-3.46,3.816a.5.5,0,0,1-.761,0l-3.46-3.816A.6.6,0,0,1,11.833,192Z",
    transform: "translate(-192 19.295) rotate(-90)",
    fill: "#74B1EE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueCaret);
export default __webpack_public_path__ + "static/media/blue_caret.d377df0ebfa41f568f2688cc3adf735a.svg";
export { ForwardRef as ReactComponent };